import { lazy } from 'react';

export { default as UserLogin } from './user_login/UserLogin';
export { default as RoleSelection } from './user_login/RoleSelection';
export { default as ChangePassword } from './change_password/ChangePassword';

export const Profile = lazy(() => import('./profile/Profile'));
export const UserList = lazy(() => import('./user/UserList'));
export const AddUser = lazy(() => import('./user/AddUser'));
export const UpdateUser = lazy(() => import('./user/UpdateUser'));
export const PremiseUserList = lazy(() => import('./premise_user/PremiseUserList'));
export const AddPremiseUser = lazy(() => import('./premise_user/AddPremiseUser'));
export const UpdatePremiseUser = lazy(() => import('./premise_user/UpdatePremiseUser'));
export const PremiseUserDetails = lazy(() => import('./premise_user/PremiseUserDetails'));
export const ServiceProviderList = lazy(() => import('./serviceProvider/ServiceProviderList'));
export const AddServiceProvider = lazy(() => import('./serviceProvider/AddServiceProvider'));
export const UpdateServiceProvider = lazy(() => import('./serviceProvider/UpdateServiceProvider'));
export const ServiceProviderDetails = lazy(() => import('./serviceProvider/ServiceProviderDetails'));
export const StaffAttendanceList = lazy(() => import('./staffAttendance/StaffAttendanceList'));
export const StaffAttendanceCalendar = lazy(() => import('./staffAttendance/StaffAttendanceCalendar'));
export const PremiseUserAttendanceList = lazy(() => import('./premiseUserAttendance/PremiseUserAttendanceList'));
export const PremiseUserAttendanceCalendar = lazy(() => import('./premiseUserAttendance/PremiseUserAttendanceCalendar'));
export const ChangeRequestList = lazy(() => import('./change_request/ChangeRequestList'));
export const XpressAdmins = lazy(() => import('./xpress_admins/XpressAdmins')); 
export const StaffManagement = lazy(() => import('./staff_management/StaffManagement'));
export const PayrollSummary = lazy(() => import('./staff_management/PayrollSummary'));
export const PayrollSummaryDetail = lazy(() => import('./staff_management/PayrollSummaryDetail'));
export const RoleAndUser = lazy(() => import('./roles_and_users/RoleAndUser')); 
export const ExpressAdminRolesUsers = lazy(() => import('./express_admin_role_user/ExpressAdminRolesUsers'));